export const reviewConstants = {
 
   ADD_REVIEW_REQUEST:      'ADD_REVIEW_REQUEST',
   ADD_REVIEW_SUCCESS:      'ADD_REVIEW_SUCCESS',
   ADD_REVIEW_FAILURE:      'ADD_REVIEW_FAILURE',
   GET_REVIEW_REQUEST:      'GET_REVIEW_REQUEST',
   GET_REVIEW_SUCCESS:      'GET_REVIEW_SUCCESS',
   GET_REVIEW_FAILURE:      'GET_REVIEW_FAILURE',
   UPDATE_REVIEW_REQUEST:   'UPDATE_REVIEW_REQUEST',
   UPDATE_REVIEW_SUCCESS:   'UPDATE_REVIEW_SUCCESS',
   UPDATE_REVIEW_FAILURE:   'UPDATE_REVIEW_FAILURE',
   GET_REVIEW_DETAILS_REQUEST:'GET_REVIEW_DETAILS_REQUEST',
   GET_REVIEW_DETAILS_SUCCESS:'GET_REVIEW_DETAILS_SUCCESS',
   GET_REVIEW_DETAILS_FAILURE:'GET_REVIEW_DETAILS_FAILURE',
   GET_REVIEW_REQUEST_FOR_ADMIN:'GET_REVIEW_REQUEST_FOR_ADMIN',
   GET_REVIEW_SUCCESS_FOR_ADMIN:'GET_REVIEW_SUCCESS_FOR_ADMIN',
   GET_REVIEW_FAILURE_FOR_ADMIN:'GET_REVIEW_FAILURE_FOR_ADMIN',
   CHANGE_REVIEW_STATUS_REQUEST:'CHANGE_REVIEW_STATUS_REQUEST',
   CHANGE_REVIEW_STATUS_SUCCESS:'CHANGE_REVIEW_STATUS_SUCCESS',
   CHANGE_REVIEW_STATUS_FAILURE:'CHANGE_REVIEW_STATUS_FAILURE',
   DELETE_REVIEW_REQUEST:'DELETE_REVIEW_REQUEST',
   DELETE_REVIEW_SUCCESS:'DELETE_REVIEW_SUCCESS',
   DELETE_REVIEW_FAILURE:'DELETE_REVIEW_FAILURE',
   UPDATE_REVIEW_BY_ADMIN_REQUEST:'UPDATE_REVIEW_BY_ADMIN_REQUEST',
   UPDATE_REVIEW_BY_ADMIN_SUCCESS:'UPDATE_REVIEW_BY_ADMIN_SUCCESS',
   UPDATE_REVIEW_BY_ADMIN_FAILURE:'UPDATE_REVIEW_BY_ADMIN_FAILURE',
   GET_REVIEW_DETAILS_FOR_ADMIN_REQUEST:'GET_REVIEW_DETAILS_FOR_ADMIN_REQUEST',
   GET_REVIEW_DETAILS_FOR_ADMIN_SUCCESS:'GET_REVIEW_DETAILS_FOR_ADMIN_SUCCESS',
   GET_REVIEW_DETAILS_FOR_ADMIN_FAILURE:'GET_REVIEW_DETAILS_FOR_ADMIN_FAILURE'
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/reviewConstants.js